export class FadeInText {
    constructor() {

        this.init();
    }
    private init(): void {
        const text = document.querySelectorAll<HTMLElement>('.fade-in-text');
        const addAnimationClass = (text: HTMLImageElement) => {
            if (!text.classList.contains("animate")) {
                text.classList.add("animate");
            }
        };
        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const img = entry.target as HTMLImageElement;
                        addAnimationClass(img);
                        obs.unobserve(img);
                    }
                });
            },
            {
                root: null,
                threshold: 0.1,
            }
        );
        text.forEach((text) => observer.observe(text));
    }
}